var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEditPencil = function SvgEditPencil(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4107 1.07741C14.7361 0.751969 15.2637 0.751969 15.5892 1.07741L18.9225 4.41074C19.2479 4.73618 19.2479 5.26381 18.9225 5.58925L5.58917 18.9226C5.43289 19.0789 5.22093 19.1667 4.99992 19.1667H1.66659C1.20635 19.1667 0.833252 18.7936 0.833252 18.3333V15C0.833252 14.779 0.921049 14.567 1.07733 14.4107L14.4107 1.07741ZM2.49992 15.3452V17.5H4.65474L17.1547 4.99999L14.9999 2.84517L2.49992 15.3452Z",
    fill: "#576777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1665 18.3333C9.1665 17.8731 9.5396 17.5 9.99984 17.5H18.3332C18.7934 17.5 19.1665 17.8731 19.1665 18.3333C19.1665 18.7936 18.7934 19.1667 18.3332 19.1667H9.99984C9.5396 19.1667 9.1665 18.7936 9.1665 18.3333Z",
    fill: "#576777"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9165 2.98814L17.0117 7.08332L15.8332 8.26183L11.738 4.16666L12.9165 2.98814Z",
    fill: "#576777"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditPencil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit-pencil.f54e7792.svg";
export { ForwardRef as ReactComponent };